export const CACHE_LEVEL_STATUS = Object.freeze({
  CACHED: 'cached',
  DOWNLOADING: 'downloading',
  BUNDLED: 'bundled',
});

export const initCache = () => {};

export const downloadLevel = (level) => {};
